import Header from '@components/Header';
import Loading from '@components/Loading';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import BoardDetailHeader from '../components/BoardDetailHeader';
import BoardHtmlContent from '../components/BoardHtmlContent';
import useNotice from './hooks/useNotice';

interface Params {
    noticeId: string;
}

declare module '@stackflow/config' {
    interface Register {
        NoticeActivity: Params;
    }
}

const NoticeActivity: ActivityComponentType<'NoticeActivity'> = ({ params }) => {
    const { noticeId } = params;
    const notice = useNotice(noticeId);
    const { t } = useTranslation('notice');
    return (
        <AppScreen>
            <Header title={t('header.title')} />
            {notice ? (
                <Fragment>
                    <BoardDetailHeader title={notice.title}
                        startAt={notice.startAt}
                        endAt={notice.endAt} />
                    <BoardHtmlContent content={notice.content}/>
                </Fragment>
            ) : (<Loading/>)}
        </AppScreen>
    );
};

export default NoticeActivity;
